import React from 'react'
import { styled } from 'linaria/react'
import { useIntl } from '@jetshop/intl'
import { Filter, ViewGrid } from 'iconoir-react'

const ButtonsWrapper = styled.div`
   display: flex;
   gap: 0.5rem;

   .mobile-filter-button {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      height: 48px;
      padding: 0 1rem;
      border: none;
      border-radius: 999px;
      background-color: var(--color-vb-blue);
      color: var(--color-white);
      font-family: var(--font-industry);
      font-weight: 700;
      font-size: 1rem;
      cursor: pointer;

      &:active {
         background-color: var(--color-vb-blue-darker);
      }
   }

   .mobile-filter-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 22px;
      height: 22px;
      padding: 0 6px;
      border-radius: 999px;
      background-color: var(--color-white);
      color: var(--color-vb-blue);
      font-size: 0.8rem;
   }
`

/**
 * Category and filter buttons shown above the product grid on mobile.
 */
const MobileFilterButtons = ({
   showCategoriesButton,
   onCategoriesClick,
   onFilterClick,
   activeFilterCount = 0,
   className,
}) => {
   const t = useIntl()
   return (
      <ButtonsWrapper className={className}>
         {showCategoriesButton && (
            <button
               type="button"
               className="mobile-filter-button"
               onClick={onCategoriesClick}
            >
               <ViewGrid width={20} height={20} strokeWidth={2} />
               {t('categories')}
            </button>
         )}
         <button
            type="button"
            className="mobile-filter-button"
            onClick={onFilterClick}
         >
            <Filter width={20} height={20} strokeWidth={2} />
            Filter
            {activeFilterCount > 0 && (
               <span className="mobile-filter-badge">{activeFilterCount}</span>
            )}
         </button>
      </ButtonsWrapper>
   )
}

export default MobileFilterButtons
